export default class DiscountApplication {
  allocationMethod!: string;
  targetSelection!: string;
  targetType!: string;
  value!: string;

  constructor(response?: any) {
    if (response != null) {
      this.allocationMethod = response.allocationMethod;
      this.targetSelection = response.targetSelection;
      this.targetType = response.targetType;
      this.value = response.value;
    }
  }
}
